import { render, staticRenderFns } from "./LoginRoute.vue?vue&type=template&id=1207c7a3&scoped=true&"
import script from "./LoginRoute.vue?vue&type=script&lang=js&"
export * from "./LoginRoute.vue?vue&type=script&lang=js&"
import style0 from "./LoginRoute.vue?vue&type=style&index=0&id=1207c7a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207c7a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VImg,VTextField})
